module.exports = __webpack_public_path__ + "static/media/lib1.a977737a.jpg";